var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    enableBackground: "new 0 0 70 70",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    d: "M50.786,0.5H21.214c-3.397,0-6.161,2.764-6.161,6.161v56.678c0,3.397,2.764,6.161,6.161,6.161h29.572 c3.396,0,6.16-2.764,6.16-6.161V6.661C56.946,3.264,54.183,0.5,50.786,0.5z M17.518,12.822h36.964v46.821H17.518V12.822z  M21.214,2.964h29.572c2.037,0,3.696,1.659,3.696,3.696v3.697H17.518V6.661C17.518,4.623,19.176,2.964,21.214,2.964z  M50.786,67.036H21.214c-2.038,0-3.696-1.658-3.696-3.697v-1.231h36.964v1.231C54.482,65.378,52.823,67.036,50.786,67.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    d: "M32.304,7.893h7.393c1.632,0,1.63-2.464,0-2.464h-7.393C30.672,5.429,30.674,7.893,32.304,7.893z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#363636",
    cx: 44.625,
    cy: 6.661,
    r: 1.232
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    d: "M48.872,27.737l-12.321-6.161c-0.347-0.173-0.755-0.173-1.103,0l-12.322,6.161 c-0.405,0.203-0.68,0.675-0.68,1.103v14.786c0,0.467,0.264,0.894,0.681,1.104l12.322,6.16c0.44,0.157,0.552,0.196,1.103,0 l12.321-6.16c0.417-0.21,0.681-0.637,0.681-1.104V28.839C49.554,28.413,49.279,27.941,48.872,27.737L48.872,27.737z M36,24.056 l9.566,4.783L36,33.623l-9.566-4.783L36,24.056z M24.911,30.833l9.857,4.929v12.03l-9.857-4.929V30.833z M37.232,47.792v-12.03 l9.856-4.929v12.03L37.232,47.792z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.b8d2f3e142efa2fc1130510b44f78c98.svg";
export { ForwardRef as ReactComponent };